const resolveThemeMode = (storedThemeMode, prefersDark) => {
    if (storedThemeMode === 'lightMode' || storedThemeMode === 'darkMode') {
        return storedThemeMode;
    }
    return prefersDark ? 'darkMode' : 'lightMode';
};

const themeBootstrapScript = `(${((resolveTheme) => {
    let storedThemeMode;
    try {
        storedThemeMode = window.localStorage.getItem('theme');
    } catch (error) {
        storedThemeMode = undefined;
    }

    let prefersDark = false;
    try {
        prefersDark = Boolean(
            window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches,
        );
    } catch (error) {
        prefersDark = false;
    }
    const themeMode = resolveTheme(storedThemeMode, prefersDark);
    document.documentElement.dataset.themeMode = themeMode;
    document.documentElement.style.colorScheme = themeMode === 'darkMode' ? 'dark' : 'light';
}).toString()})(${resolveThemeMode.toString()});`;

const themeBootstrapStyles = `
:root {
    --site-background: #fcfcfc;
    --site-text: #191919;
    --site-muted: #5b5b5b;
    --site-surface: #ffffff;
    --site-header-background: #ffffff;
    --site-header-shadow: 4px 0 8px rgba(0, 0, 0, 0.125);
    --site-shadow-small: 0 2px 4px rgba(0, 0, 0, 0.125);
    --site-shadow-default: 0 4px 8px rgba(0, 0, 0, 0.125);
}

:root[data-theme-mode='darkMode'] {
    --site-background: #121212;
    --site-text: #f1f1f1;
    --site-muted: #bababa;
    --site-surface: #1f1f1f;
    --site-header-background: #1c1c1c;
    --site-header-shadow: 4px 0 8px rgba(0, 0, 0, 0.4);
    --site-shadow-small: 0 2px 4px rgba(0, 0, 0, 0.25);
    --site-shadow-default: 0 4px 8px rgba(0, 0, 0, 0.25);
}

html[data-theme-mode] body {
    background: var(--site-background);
    color: var(--site-text);
}

html:not([data-react-theme-ready='true']) [class*='HeaderContainer'] {
    background-color: var(--site-header-background) !important;
    box-shadow: var(--site-header-shadow) !important;
    transition: none !important;
}
`;

module.exports = { resolveThemeMode, themeBootstrapScript, themeBootstrapStyles };
